<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-6">
<h1 class="toc">CONTENTS</h1>
</a><h2 class="toc1"><a id="VPS-6"></a><a href="#/xhtml/006_Preface">Preface</a></h2>
<h2 class="toc1"><a href="#/xhtml/007_Acknowledgements">Acknowledgments</a></h2>
<h2 class="toc1"><a href="#/xhtml/009_Introduction">Introduction</a></h2>
<h2 class="toc2"><a href="#/xhtml/010_Chapter_1">PART ONE:</a></h2>
<h2 class="toc2_RM"><a href="#/xhtml/010_Chapter_1">ETHICS AT WORK</a></h2>
<h3 class="toc3"><a href="#/xhtml/011_Chapter_2">1. Employing Parents Who Can’t Make a Living</a></h3>
<h3 class="toc4"><span href="#/xhtml/012_Chapter_3" title="Link target outside of Sample">2. The Meaning of Work Ethic</span></h3>
<h3 class="toc4"><span href="#/xhtml/013_Chapter_4" title="Link target outside of Sample">3. American Bosses: Sympathetic, Amoral Marketeers, and a Few Rule Breakers</span></h3>
<h2 class="toc2"><span href="#/xhtml/014_Chapter_5" title="Link target outside of Sample">PART TWO:</span></h2>
<h2 class="toc2_RM"><span href="#/xhtml/014_Chapter_5" title="Link target outside of Sample">TROUBLING CHILDREN</span></h2>
<h3 class="toc3"><span href="#/xhtml/015_Chapter_6" title="Link target outside of Sample">4. Working for the Good of the Child</span></h3>
<h3 class="toc4"><span href="#/xhtml/016_Chapter_7" title="Link target outside of Sample">5. “Irresponsible” Parenting or Social Neglect?</span></h3>
<h3 class="toc4"><span href="#/xhtml/017_Chapter_8" title="Link target outside of Sample">6. Beyond Blame: Recognizing Unequal Choices</span></h3>
<h2 class="toc2"><span href="#/xhtml/018_Chapter_9" title="Link target outside of Sample">PART THREE:</span></h2>
<h2 class="toc2_RM"><span href="#/xhtml/018_Chapter_9" title="Link target outside of Sample">THE SICKENING EFFECTS OF POVERTY</span></h2>
<h3 class="toc3"><span href="#/xhtml/019_Chapter_10" title="Link target outside of Sample">7. A Healer’s Dilemma</span></h3>
<h3 class="toc4"><span href="#/xhtml/020_Chapter_11" title="Link target outside of Sample">8. Trying to Heal Economic Harms</span></h3>
<a id="VPS-7">
</a><h2 class="toc2"><a id="VPS-7"></a><span href="#/xhtml/021_Chapter_12" title="Link target outside of Sample">PART FOUR:</span></h2>
<h2 class="toc2_RM"><span href="#/xhtml/021_Chapter_12" title="Link target outside of Sample">RAISING A MORAL UNDERGROUND</span></h2>
<h3 class="toc3"><span href="#/xhtml/022_Chapter_13" title="Link target outside of Sample">9. Roots of Disobedience</span></h3>
<h3 class="toc4"><span href="#/xhtml/023_Chapter_14" title="Link target outside of Sample">10. Raising a Moral Underground</span></h3>
<h2 class="toc5"><span href="#/xhtml/024_BM1" title="Link target outside of Sample">Addendum: Research as Democracy</span></h2>
<h2 class="toc1"><span href="#/xhtml/025_Endnotes" title="Link target outside of Sample">Notes</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1a7ed528